export const ENTER_KEY = "Enter";
export const PAGE_NOT_FOUND = "Page Not Found";

// #region Routes
export const AvailableBaseRoutes = {
  Portal: "/portal",
  Login: "/login",
  Unlock: "/unlock",
  Contact: "/portal/contact",
  DataPrivacy: "/portal/data-privacy",
  // Group
  Group: "/portal/groups",
  GroupList: "/portal/groups",
  GroupDetail: "/portal/groups/:erpNumber",

  // Users
  UserList: "/portal/users",
};

export const AvailablePomRoutes = {
  Reporting: "/portal/pom/announcement",
  UserNew: "/portal/pom/users/new",
  Agency: "/portal/pom/agency",
  ManufacturerCreate: "/portal/pom/manufacturers/add",
  ManufacturerDetail: "/portal/pom/manufacturers/:id",
  ManufacturerEdit: "/portal/pom/manufacturers/:id/edit",
  Portal: "/portal/pom",
};

export const AvailableConfiguratorRoutes = {
  Portal: "/portal/config",
};
// #endregion
export const isPomRoute = (route: string) => route.startsWith("/portal/pom/");
export const isConfigRoute = (route: string) => route.startsWith("/portal/config/");
/** `Routes.tsx` renders the login page for "/" too, so both paths count as the login route. */
export const isLoginRoute = (route: string) =>
  route === "/" || route === AvailableBaseRoutes.Login || route.startsWith(`${AvailableBaseRoutes.Login}/`);

export const SCROLL_TO_TOP_BUTTON_HEIGHT = 60;
export const SCROLL_TO_TOP_BUTTON_MIN_WIDTH = 60;
export const TEXT_SEPARATOR = ",";
